import React from "react";
import {
  Box,
  Image,
  usePrefersReducedMotion,
  BoxProps,
} from "@chakra-ui/react";
import { css, keyframes } from "@emotion/react";

interface LoadingLogoProps extends BoxProps {
  size?: "sm" | "md" | "lg" | "xl";
}

const LoadingLogo: React.FC<LoadingLogoProps> = ({ size = "md", ...props }) => {
  const prefersReducedMotion = usePrefersReducedMotion();

  // Define keyframes for animations
  const rotate = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  `;

  const pulse = keyframes`
    0% { transform: scale(0.95); opacity: 0.7; }
    50% { transform: scale(1.05); opacity: 1; }
    100% { transform: scale(0.95); opacity: 0.7; }
  `;

  // Size mapping
  const sizeMap = {
    sm: "30px",
    md: "40px",
    lg: "60px",
    xl: "80px",
  };

  const boxSize = sizeMap[size];

  return (
    <Box position="relative" width={boxSize} height={boxSize} {...props}>
      {/* Spinning logo */}
      <Image
        src="/logo.svg"
        alt="Loading"
        boxSize={boxSize}
        position="absolute"
        top="0"
        left="0"
        css={
          !prefersReducedMotion &&
          css`
            animation: ${rotate} 2s linear infinite;
          `
        }
      />

      {/* Pulsing background layer */}
      <Image
        src="/logo.svg"
        alt=""
        aria-hidden="true"
        boxSize={boxSize}
        position="absolute"
        top="0"
        left="0"
        opacity="0.4"
        zIndex="-1"
        css={
          !prefersReducedMotion &&
          css`
            animation: ${pulse} 1.5s ease-in-out infinite;
          `
        }
      />
    </Box>
  );
};

export default LoadingLogo;
